export class SearchEvent {
    constructor(public searchId) {}
}
